import { Injectable } from '@angular/core';

@Injectable()
export class CookieKeys {
  // AUTHENTICATION
  public static readonly HE_AUTH_TOKEN = 'he-auth-token';
}
